import { z } from 'zod'
import { LIBRARY_VIEW_COLUMNS_MAX, columnIdSchema } from './library-columns'
import { streamFiltersSchema } from './stream'

// ── Library saved views ───────────────────────────────────────────────────────────────────────

export const sortStateSchema = z.object({
  id: columnIdSchema,
  dir: z.enum(['asc', 'desc']),
})
export type SortState = z.infer<typeof sortStateSchema>

/** A saved reading position: filters and sort, restored together. Its `columns` are what the
 *  workspace showed when it was saved — the columns themselves are the workspace's
 *  (`libraryLayoutSchema`), so restoring a view never changes them. */
export const libraryViewSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  filters: streamFiltersSchema,
  sort: sortStateSchema,
  columns: z.array(columnIdSchema),
  /** The view the Library opens on for this workspace; at most one per sub-account. */
  starred: z.boolean(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
})
export type LibraryView = z.infer<typeof libraryViewSchema>

export const createLibraryViewSchema = z.object({
  name: z.string().trim().min(1).max(120),
  filters: streamFiltersSchema,
  sort: sortStateSchema,
  columns: z.array(columnIdSchema).min(1).max(LIBRARY_VIEW_COLUMNS_MAX),
  starred: z.boolean().default(false),
})
export type CreateLibraryView = z.infer<typeof createLibraryViewSchema>

export const updateLibraryViewSchema = createLibraryViewSchema.partial()
export type UpdateLibraryView = z.infer<typeof updateLibraryViewSchema>

export const listLibraryViewsResponseSchema = z.object({ views: z.array(libraryViewSchema) })
export type ListLibraryViewsResponse = z.infer<typeof listLibraryViewsResponseSchema>
